import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "fifPlKindInputContainer",
    "fifPlKindInput",
    "nestedOutOfFifPlInvoicePaymentInstallmentsFields",
    "invoiceFirstName",
    "invoiceLastName",
    "invoiceAddress",
    "invoiceEmail"
  ]

  static values = {
    traineeFirstName: String,
    traineeLastName: String,
    traineeCompanyAddressDisplayName: String,
    traineeEmail: String
  }

  updateFifPlRelatedFields (event) {
    if (event.target.value === "fif_pl") {
      this._showFifPlKindInput(event.target)
    } else {
      this._hideFifPlKindInput(event.target)
      if (event.target.value === "out_of_fif_pl") this._showPaymentInstallments(event.target)
    }
  }

  _showFifPlKindInput (kindInput) {
    this._fifPlKindInputContainerForKindInput(kindInput)?.classList.remove("d-none")
  }

  _hideFifPlKindInput (kindInput) {
    this._fifPlKindInputContainerForKindInput(kindInput)?.classList.add("d-none")

    const fifPlKindInput = this._fifPlKindInputForKindInput(kindInput)
    if (fifPlKindInput) fifPlKindInput.value = ""
  }

  _showPaymentInstallments (kindInput) {
    const target = this._paymentInstallmentsFieldsForKindInput(kindInput)
    if (!target) return

    target.classList.remove('d-none')
    this._addPaymentInstallmentIfEmpty(target, kindInput)
    this._updateInvoiceFields()
  }

  _fifPlKindInputContainerForKindInput (kindInput) {
    return this._wrapperForKindInput(kindInput)
      ?.querySelector("[data-enrollments--financement-mode-target~='fifPlKindInputContainer']")
  }

  _fifPlKindInputForKindInput (kindInput) {
    return this._wrapperForKindInput(kindInput)
      ?.querySelector("[data-enrollments--financement-mode-target~='fifPlKindInput']")
  }

  _paymentInstallmentsFieldsForKindInput (kindInput) {
    const wrapper = this._wrapperForKindInput(kindInput)
    const fields = Array.from(wrapper?.querySelectorAll("[data-enrollments--financement-mode-target~='nestedOutOfFifPlInvoicePaymentInstallmentsFields']") || [])

    return fields.find((field) => !field.classList.contains("d-none")) || fields[fields.length - 1]
  }

  _wrapperForKindInput (kindInput) {
    return kindInput.closest(".nested-form-wrapper")
  }

  _addPaymentInstallmentIfEmpty (paymentInstallmentsFields, kindInput) {
    const paymentInstallments = Array.from(paymentInstallmentsFields.querySelectorAll(".nested-form__item"))
      .filter((item) => !item.closest("template"))
    if (paymentInstallments.length > 0) return

    paymentInstallmentsFields
      .querySelector("[data-action=\"enrollments--nested-form-payment-installments#add\"]")
      ?.click()

    const paymentInstallment = Array.from(paymentInstallmentsFields.querySelectorAll(".nested-form__item"))
      .filter((item) => !item.closest("template"))
      .at(-1)
    const amountInput = paymentInstallment?.querySelector("[data-input-kind=\"amount\"]")
    const financementModeAmountInput = this._wrapperForKindInput(kindInput)
      ?.querySelector("[data-enrollments--form-target~='financementModeAmountInput']")

    if (amountInput && financementModeAmountInput) amountInput.value = financementModeAmountInput.value
  }

  _updateInvoiceFields () {
    this.invoiceFirstNameTargets.forEach((target) => { target.value = this.traineeFirstNameValue })
    this.invoiceLastNameTargets.forEach((target) => { target.value = this.traineeLastNameValue })
    this.invoiceAddressTargets.forEach((target) => { target.value = this.traineeCompanyAddressDisplayNameValue })
    this.invoiceEmailTargets.forEach((target) => { target.value = this.traineeEmailValue })
  }
}
